import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../_core/_services/notification.service';
import { SupportService } from '../../../_core/_services/support/support.service';
import {
  SupportDashboardSummaryDto,
  SupportTicketCategory,
  SupportTicketListItemDto,
  SupportTicketPriority,
  SupportTicketStatus
} from '../../../_core/_model/support/support';

@Component({
  selector: 'app-admin-support-tickets',
  standalone: false,
  templateUrl: './admin-support-tickets.html',
  styleUrl: './admin-support-tickets.css'
})
export class AdminSupportTickets implements OnInit {
  loading = false;
  tickets: SupportTicketListItemDto[] = [];

  search = '';
  status: SupportTicketStatus | '' = '';
  category: SupportTicketCategory | '' = '';
  priority: SupportTicketPriority | '' = '';
  
  summary: SupportDashboardSummaryDto | null = null;

  readonly statuses: SupportTicketStatus[] = [
    'Open',
    'InProgress',
    'WaitingForUser',
    'WaitingForAdmin',
    'Resolved',
    'Closed'
  ];

  readonly categories: SupportTicketCategory[] = [
    'General',
    'Deposit',
    'Withdrawal',
    'Order',
    'Compliance',
    'Account',
    'Technical'
  ];

  readonly priorities: SupportTicketPriority[] = [
    'Low',
    'Normal',
    'High',
    'Urgent'
  ];

  constructor(
    private supportService: SupportService,
    private notifyService: NotificationService
  ) {}

  ngOnInit(): void {
    this.loadTickets();
    this.loadSummary();
  }

  loadTickets(): void {
    this.loading = true;

    this.supportService.getAdminTickets(
      1,
      undefined,
      this.search || undefined,
      this.status || null,
      this.category || null,
      this.priority || null
    ).subscribe({
      next: (res) => {
        this.tickets = res.data || [];
      },
      error: (err) => {
        this.tickets = [];
        this.notifyService.showError(
          err?.error?.message || 'Failed to load support tickets.',
          'Error'
        );
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  loadSummary(): void {
    this.supportService.getAdminSupportSummary().subscribe({
      next: (res) => {
        this.summary = res.data || null;
      },
      error: () => {
        this.summary = null;
      }
    });
  }
  
  clearFilters(): void {
    this.search = '';
    this.status = '';
    this.category = '';
    this.priority = '';
    this.loadSummary();
    this.loadTickets();
  }

  filterUnresolved(): void {
    this.status = '';
    this.loadTickets();
  }

  filterByStatus(status: SupportTicketStatus): void {
    this.status = status;
    this.loadTickets();
  }

  quickUpdateStatus(ticketId: string, status: SupportTicketStatus): void {
    this.supportService.updateAdminTicketStatus(ticketId, status).subscribe({
      next: () => {
        this.loadTickets();
        this.loadSummary();
      },
      error: () => {
        this.notifyService.showError('Failed to update status', 'Error');
      }
    });
  }
}